import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router'
import { useFormik } from 'formik';
import * as yup from "yup";

import { Grid } from '@mui/material';
import { ThemeProvider } from "@mui/material/styles";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import styles from "../../styles/Form.module.css";
import mainTheme from '../../components/mainTheme';
import { getCookie } from "cookies-next";

const validationSchema = yup.object({
  email: yup
    .string('Enter your email')
    .email('Enter a valid email')
    .required('Email is required'),
  name: yup
    .string('Enter your name')
    .required('Name is required'),
});

const FormMini = ({listId, formName, successUrl, successMsg, buttonText, fieldList, utmOverride}) => {
  successUrl = successUrl || '';
  successMsg = successMsg || <strong>Thank you for your interest!</strong>;
  buttonText = buttonText || 'Submit';
  fieldList = fieldList || ['name', 'email'];

  const [formState, setFormState] = useState('incomplete');
  const [findState, setFindState] = useState(false);
  const [recipState, setRecipState] = useState({
    email: '',
    name: '',
    recipientId: 0
  });
  const router = useRouter();
  
  const convertRecipObj = (dataObj) => {
    setFindState(true);
    if (dataObj.data.email){
      setRecipState({
        email:dataObj.data.email,
      })
    }
  }

  const saveRecipFinished = () => {
    if(formState !== 'success') {
      setFormState('success');
    }
  }

  const formik = useFormik({
    initialValues: {
      name: recipState.name,
      email: recipState.email,
      form: formName,
      list: listId,
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      // split name
      let firstName = '';
      let lastName = '';
      let namePieces = values.name.split(" ");
      if(namePieces.length == 1){
        firstName = values.name;
      }
      if(namePieces.length >= 2){
        firstName = namePieces[0];
        lastName = namePieces.slice(1).join(" ");
      }

      let cookies = getCookie("elmlead");
      if(cookies && cookies.length > 1){
        cookies = JSON.parse(cookies);
      }

      let utm_content = cookies && cookies.utm_content ? cookies.utm_content : ""
      if(utmOverride && utmOverride.length > 0){
        utm_content = utmOverride;
      }

      const body = {
        ...values,
        firstname: firstName,
        lastname: lastName,
        utm_campaign: cookies && cookies.utm_campaign ? cookies.utm_campaign : "",
        utm_source: cookies && cookies.utm_source ? cookies.utm_source : "",
        utm_medium: cookies && cookies.utm_medium ? cookies.utm_medium : "",
        utm_term: cookies && cookies.utm_term ? cookies.utm_term : "",
        utm_content: utm_content
      };
      return fetch("https://easyemerge.com/plugins/elevate_form.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.message === "ok") {
            setFormState( "success" );

            if (window.fbq) {
              window.fbq("track", "Lead");
            }
            if (window.gtag) {
              window.gtag("event", "conversion", {
                send_to: "AW-980447970/2_aHCOnsjo8BEOLlwdMD",
              });
            }
            if (window.ga) {
              window.ga("send", "event", "form", "form_completed", "get-started");
            }
          } else {
            setFormState( "error" );
          }
        })
        .catch((err) => {
          setFormState( "error" );
        });
      
    },
  });

  if(formState === 'success'){  
    let thisHost = process.env.URL
    let baseDomain = '';
    
    if(successUrl.length > 4){
      if(!thisHost){
        let pathname = router.pathname;
        let pieces = pathname.split("/");
        let i;
        for(i=0;i<pieces.length;i++){
            if(pieces[i].length > 0){
                baseDomain = pieces[i];
                break;
            }
        }
        successUrl = "/" + baseDomain + successUrl;
      }

      location.href = successUrl;
      return true;
    }

    return (
      <div style={{marginTop:"12px"}}>
        {successMsg}
      </div>
    )
  }

  return (
    <ThemeProvider theme={mainTheme}>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={0} >
          {fieldList.includes('name') && 
          <Grid item md={12} sm={12} xs={12} style={{marginBottom:"8px"}}>
          <TextField
            fullWidth
            id={`name-${formName}`}
            name="name"
            label="Name"
            type="text"
            value={formik.values.name}
            onChange={formik.handleChange}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
            className={styles.inputField}
            size="small"
            inputProps={{"aria-label":`Full Name field for ${formName}`}}
          />
          </Grid>}
          {fieldList.includes('email') && 
          <Grid item md={12} sm={12} xs={12} style={{marginBottom:"8px"}}>
          <TextField
            fullWidth
            id={`email-${formName}`}
            name="email"
            label="Email"
            type="text"
            value={formik.values.email}
            onChange={formik.handleChange}
            error={formik.touched.email &&Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
            className={styles.inputField}
            size="small"
            inputProps={{"aria-label":`Email field for ${formName}`}}
          /></Grid>
          }
          {fieldList.includes('phone') && 
          <Grid item md={12} sm={12} xs={12} style={{marginBottom:"8px"}}>
          <TextField
            fullWidth
            id={`phone-${formName}`}
            name="phone"
            label="Phone"
            type="tel"
            value={formik.values.phone}
            onChange={formik.handleChange}
            error={formik.touched.phone && Boolean(formik.errors.phone)}
            helperText={formik.touched.phone && formik.errors.phone}
            className={styles.inputField}
            size="small"
          /></Grid>
          }
          {fieldList.includes('company') && 
          <Grid item md={12} sm={12} xs={12} style={{marginBottom:"8px"}}>
          <TextField
            fullWidth
            id={`company-${formName}`}
            name="company"
            label="Company/Affiliation"
            type="text"
            value={formik.values.company}
            onChange={formik.handleChange}
            error={formik.touched.company && Boolean(formik.errors.company)}
            helperText={formik.touched.company && formik.errors.company}
            className={styles.inputField}
            size="small"
            inputProps={{"aria-label":`Company field for ${formName}`}}
          /></Grid>
          }
        </Grid>

        <Button variant="contained" size="large" type="submit" color="secondary" aria-label="Submit form">
          {buttonText}
        </Button>
      </form>
    </ThemeProvider>
  );
};

export default FormMini;